import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import "./SearchBox.css";

const SearchBox = (props) => {
  const [searchValue, setSearchValue] = useState("");
  const { searchHeader, submitHandler, preHeaderText } = props;

  return (
    <div className="searchbox">
      <div className="left-side">
        {preHeaderText ? <p>{preHeaderText}</p> : ""}
        <h3>{searchHeader}</h3>
        <textarea
          className="search-input"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        ></textarea>
        <Button
          className="submit-btn"
          onClick={() => submitHandler(searchValue)}
        >
          Search
        </Button>
      </div>
    </div>
  );
};

export default SearchBox;
